function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider, getConfig } from '@okee-uikit/react-config';
import { isServer } from '@okee-uikit/react-utils';
import { FullLoading } from './FullLoading';
var container = null;

if (!isServer()) {
  container = document.createElement('div');
}

export function create(props) {
  var globalConfig = getConfig();

  var render = function render() {
    if (!container) return;

    if (!document.body.contains(container)) {
      document.body.appendChild(container);
    }

    ReactDOM.render(React.createElement(ConfigProvider, {
      value: globalConfig
    }, React.createElement(FullLoading, _objectSpread({
      show: true
    }, props))), container);
  };

  var destroy = function destroy() {
    if (!container) return;

    if (container.parentNode) {
      ReactDOM.unmountComponentAtNode(container);
    }
  };

  return {
    show: render,
    hide: destroy
  };
}